import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { copyTextToClipboard } from 'src/helpers/copyToClipboard';

export function useCopyFileUrl() {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  return useCallback(
    async (fileUrl: string) => {
      const copied = await copyTextToClipboard(fileUrl);
      enqueueSnackbar(
        copied ? t('system.fileManager.linkCopied') : t('system.fileManager.linkCopyFailed'),
        { variant: copied ? 'success' : 'error' },
      );
    },
    [enqueueSnackbar, t],
  );
}
